import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import './style.css'
import 'vue3-toastify/dist/index.css'
import App from './App.vue'

createApp(App).use(createPinia()).use(router).mount('#app')
